<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width }"
  [breakpoints]="{ '900px': '96vw' }"
  [header]="title"
  styleClass="hr-action-dialog"
>
  <section class="dialog-layout">
    <aside class="dialog-summary">
      <span class="summary-icon"><i [class]="icon"></i></span>
      <small>{{ eyebrow }}</small>
      <h3>{{ contextTitle || title }}</h3>
      <p>{{ subtitle }}</p>
      @if (contextSubtitle) {
        <span class="context-chip">{{ contextSubtitle }}</span>
      }
    </aside>
    <div class="dialog-form">
      <ng-content></ng-content>
    </div>
  </section>
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <ng-content select="[dialogFooter]"></ng-content>
    </div>
  </ng-template>
</p-dialog>
